import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import PopularPlaces from './components/PopularPlaces';
import SearchPage from './pages/SearchPage';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Profile from './pages/Profile';
import PlaceDetail from './pages/PlaceDetail';
import OwnerPanel from './pages/OwnerPanel';
import LoginAdmin from './pages/LoginAdmin';
import AdminPanel from './pages/AdminPanel';
import HostelDetail from './pages/HostelDetail';
import RequireAdmin from './components/RequireAdmin';
import ReservationPage from './pages/ReservationPage';
import ReservationSuccess from './pages/ReservationSuccess';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthContextProvider } from './context/AuthContext'; // ✅ Context'i sarıyoruz

const popularData = [
  /*
  {
    title: 'Popüler Yerler',
    places: [
      {
        id: '1',
        title: 'Deniz Manzaralı Pansiyon',
        location: 'Çanakkale / Kepez',
        description: 'Kıyıya sıfır panorama.',
        image: 'https://cdn.pixabay.com/photo/2015/01/13/13/21/paradise-598201_1280.jpg',
      },
      {
        id: '2',
        title: 'Orman İçinde Pansiyon',
        location: 'Antalya / Kemer',
        description: 'Doğayla iç içe konfor.',
        image: 'https://cdn.pixabay.com/photo/2016/02/18/22/16/tents-1208261_1280.jpg',
      },
      {
        id: '3',
        title: 'Göl Kenarı Pansiyon',
        location: 'Bolu / Abant',
        description: 'Göl manzaralı huzur.',
        image: 'https://cdn.pixabay.com/photo/2020/04/25/07/13/forest-5082006_1280.jpg',
      },
      {
        id: '4',
        title: 'Dağ Zirvesi Pansiyon',
        location: 'Erzurum / Palandöken',
        description: 'Kar manzaralı sıcacık odalar.',
        image: 'https://cdn.pixabay.com/photo/2017/01/17/21/03/ski-resort-1988403_1280.jpg',
      },
    ],
  },*/
  {
    title: "Çanakkale’deki Popüler Yerler",
    places: [
      {
        id: '5',
        title: 'Tarihi Konaklama',
        location: 'Çanakkale / Lapseki',
        description: 'Boğaz manzaralı ayrıcalık.',
        image: 'https://cdn.pixabay.com/photo/2017/08/07/21/10/hotel-2602244_1280.jpg',
      },
      {
        id: '6',
        title: 'Zeytin Bahçesi Pansiyon',
        location: 'Çanakkale / Ayvacık',
        description: 'Yeşillikler içinde dinlenme.',
        image: 'https://cdn.pixabay.com/photo/2019/07/02/07/59/olive-4306948_1280.jpg',
      },
      {
        id: '7',
        title: 'Ada Manzaralı Pansiyon',
        location: 'Çanakkale / Gökçeada',
        description: 'Ege’nin saklı adası.',
        image: 'https://cdn.pixabay.com/photo/2018/06/15/12/40/greece-3471894_1280.jpg',
      },
      {
        id: '8',
        title: 'Köy Evi Pansiyon',
        location: 'Çanakkale / Ayvacık',
        description: 'Taş evlerde nostalji.',
        image: 'https://cdn.pixabay.com/photo/2016/10/18/21/22/cottage-1756865_1280.jpg',
      },
    ],
  },
  /*{
    title: "İstanbul’daki Popüler Yerler",
    places: [
      {
        id: '9',
        title: 'Boğaz Köşkü Pansiyon',
        location: 'İstanbul / Bebek',
        description: 'Eşsiz boğaz manzarası.',
        image: 'https://cdn.pixabay.com/photo/2016/03/27/21/16/city-1284436_1280.jpg',
      },
      {
        id: '10',
        title: 'Tarihi Suluhan Pansiyon',
        location: 'İstanbul / Sultanahmet',
        description: 'Tarih kokan bir konaklama.',
        image: 'https://cdn.pixabay.com/photo/2019/04/17/12/05/historic-4137785_1280.jpg',
      },
      {
        id: '11',
        title: 'Moda Sahil Pansiyon',
        location: 'İstanbul / Kadıköy',
        description: 'Deniz kenarında gün batımı.',
        image: 'https://cdn.pixabay.com/photo/2017/11/06/09/53/boats-2921914_1280.jpg',
      },
      {
        id: '12',
        title: 'Galata Tepesi Pansiyon',
        location: 'İstanbul / Galata',
        description: 'Panoramik şehir manzarası.',
        image: 'https://cdn.pixabay.com/photo/2018/09/19/18/17/galata-3696914_1280.jpg',
      },
    ],
  },*/
];

export default function App() {
  return (
    <AuthProvider>
      <div className="flex flex-col min-h-screen">
        <Header />

        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <PopularPlaces />
                </>
              }
            />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<LoginAdmin />} />
            <Route
              path="/admin-panel"
              element={
                <RequireAdmin>
                  <AdminPanel />
                </RequireAdmin>
              }
            />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/owner-panel/:id" element={<OwnerPanel />} />
            <Route path="/place/:id" element={<PlaceDetail />} />
            <Route path="/hostel/:id" element={<HostelDetail />} />
            <Route path="/reservation/:id" element={<ReservationPage />} />
            <Route path="/reservation-success" element={<ReservationSuccess />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </AuthProvider>
  );
}